export default __webpack_public_path__ + "static/ILSEF-cc5db22479c1c205eaa86341a5072675.png";